import { gql, TypedDocumentNode } from "@apollo/client";
import type { UniversityStaffQuery } from "./types";

export const UNIVERSITY_STAFF_QUERY: TypedDocumentNode<UniversityStaffQuery> = gql`
  query UniversityStaff($legacyId: String!) {
    universities(legacyId: $legacyId) {
      id
      legacyId
      name
      universityStaff {
        id
        role
        createdAt
        updatedAt
        user {
          id
          name
          email
          photo
        }
      }
    }
  }
`;
